/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online loan and EMI calculator. Enter the loan amount, interest rate, and term to get the monthly payment, total repaid, and total interest. Works in your browser.`)
};

const es_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita en línea de préstamos e EMI. Ingrese el monto del préstamo, la tasa de interés y el plazo para obtener el pago mensual, el total reembolsado y el interés total. Funciona en su navegador.`)
};

const de_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Darlehens- und EMI-Rechner. Geben Sie Darlehensbetrag, Zinssatz und Laufzeit ein, um die monatliche Rate, den Gesamtrückzahlungsbetrag und die Gesamtzinsen zu erhalten. Funktioniert direkt in Ihrem Browser.`)
};

const nl_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online lening- en EMI-calculator. Voer het leningbedrag, rente en looptijd in om de maandelijkse betaling, totaal terugbetaald en totale rente te krijgen. Werkt in uw browser.`)
};

const fr_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice gratuite de prêt et d'EMI en ligne. Entrez le montant du prêt, le taux d'intérêt et la durée pour obtenir le paiement mensuel, le total remboursé et l'intérêt total. Fonctionne dans votre navigateur.`)
};

const it_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito online per prestiti e EMI. Inserisci l'importo del prestito, il tasso di interesse e la durata per ottenere il pagamento mensile, il totale rimborsato e l'interesse totale. Funziona nel tuo browser.`)
};

const pt_br2_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora online gratuita de empréstimo e EMI. Insira o montante do empréstimo, a taxa de juros e o prazo para obter o pagamento mensal, o total reembolsado e o total de juros. Funciona no seu navegador.`)
};

const pt_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita online de empréstimo e EMI. Introduza o montante do empréstimo, a taxa de juro e o prazo para obter o pagamento mensal, o total reembolsado e o total de juros. Funciona no seu navegador.`)
};

const ja_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「無料のオンラインローンおよびEMI計算機。ローン金額、金利、期間を入力して、月々の支払額、合計返済額、合計利息を計算します。ブラウザで動作します。」`)
};

const zh_ln_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线贷款与EMI计算器。输入贷款金额、利率和期限，即可获得月供、还款总额和利息总额，完全在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_meta_description", locale)
	if (locale === "en") return en_ln_meta_description(inputs)
	if (locale === "es") return es_ln_meta_description(inputs)
	if (locale === "de") return de_ln_meta_description(inputs)
	if (locale === "nl") return nl_ln_meta_description(inputs)
	if (locale === "fr") return fr_ln_meta_description(inputs)
	if (locale === "it") return it_ln_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ln_meta_description(inputs)
	if (locale === "pt") return pt_ln_meta_description(inputs)
	if (locale === "ja") return ja_ln_meta_description(inputs)
	return zh_ln_meta_description(inputs)
};